import { BlogImageRoot } from './BlogImage.styles'
import { addParameterToContentfulUrl } from 'utils/addParameterToContentfulUrl'

export type BlogImageType = {
  fields: {
    file: {
      url: string
      details: {
        image: {
          width: number
          height: number
        }
      }
    }
    title: string
  }
}

type BlogImageProps = {
  content: BlogImageType
}

export const BlogImage = ({ content, ...rest }: BlogImageProps) => {
  return (
    <BlogImageRoot {...rest}>
      <img src={`https:${addParameterToContentfulUrl(content.fields.file.url, 'fm', 'webp')}`} alt={content.fields.title} />
    </BlogImageRoot>
  )
}
